import React from 'react';
import { LayoutDashboard, Users, Briefcase, Settings } from 'lucide-react';

const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'trips', label: 'Trips', icon: Briefcase },
  { key: 'travellers', label: 'Travellers', icon: Users },
  { key: 'settings', label: 'Settings', icon: Settings },
];

/**
 * Fixed bottom tab bar (64px + iOS safe area). Instant color switch, no
 * animation. Controlled by the shell (no routing — local tab state).
 */
export const MobileBottomNav = ({ active, onChange }) => (
  <nav
    data-testid="m-bottom-nav"
    className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#E5E7EB]"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
  >
    <div className="grid grid-cols-4 h-16">
      {TABS.map((t) => {
        const Icon = t.icon;
        const on = active === t.key;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            data-testid={`m-nav-${t.key}`}
            aria-current={on ? 'page' : undefined}
            className="flex flex-col items-center justify-center gap-1"
            style={{ color: on ? '#0F6E56' : '#6B7280' }}
          >
            <Icon className="h-6 w-6" strokeWidth={on ? 2.4 : 1.9} />
            <span className="text-[10px] font-medium leading-none">{t.label}</span>
          </button>
        );
      })}
    </div>
  </nav>
);

export default MobileBottomNav;
